import type { FooterColumn, IFooterContact, LegalInfo } from '../interfaces';

export interface ProcessedFooterColumn {
  title: string;
  links: Array<{
    label: string;
    url: string;
    external: boolean;
    isBold: boolean;
    type: string;
    isOpenInNewTab: boolean;
    link?: {
      type: string;
      url: string;
    };
  }>;
}

export interface ProcessedContactInfo {
  contactItems: Array<{
    text: string;
    url: string;
    type: string;
    icon?: string;
    iconImageUrl?: string;
    isBold?: boolean;
    isOpenInNewTab: boolean;
  }>;
}

export interface ProcessedLegalProps {
  copyrightText: string;
  additionalText?: {
    text: string;
    isBold?: boolean;
    link?: {
      type?: string;
      url?: string;
      anchor?: string;
      isOpenInNewTab?: boolean;
    };
  };
  legalLinks: Array<{
    label: string;
    url: string;
    external?: boolean;
  }>;
}

export const processFooterColumns = (columns: FooterColumn[] | null = []): ProcessedFooterColumn[] => {
  return (columns || [])
    .filter((col) => col.isVisible !== false)
    .map((col) => ({
      title: col.title,
      links: (col.links || []).map((l) => ({
        label: l.label,
        url: l.url || '#',
        external: l.external ?? l.type === 'external',
        isBold: l.isBold ?? false,
        type: l.type || (l.external ? 'external' : undefined) || 'internal',
        isOpenInNewTab: l?.link?.isOpenInNewTab ?? false,
        link: l.link,
      })),
    }));
};

export const processContactInfo = (footerContact?: IFooterContact): ProcessedContactInfo | undefined => {
  if (!footerContact || !footerContact.contactItems) return undefined;

  return {
    contactItems: footerContact.contactItems.map((item) => ({
      text: item.text,
      url: item.url,
      type: item.type,
      icon: item.icon,
      iconImageUrl: item.iconImageUrl,
      isBold: item.isBold,
      isOpenInNewTab: item.type === 'external' ? true : Boolean(item.isOpenInNewTab),
    })),
  };
};

export const processLegalInfo = (legalInfo?: LegalInfo): ProcessedLegalProps => {
  const currentYear = new Date().getFullYear();
  const copyrightText =
    legalInfo?.companyName && legalInfo?.abn ? `© ${currentYear} ${legalInfo.companyName} | ABN: ${legalInfo.abn}` : '';

  return {
    copyrightText,
    additionalText: legalInfo?.additionalText,
    legalLinks: legalInfo?.legalLinks || [],
  };
};
